import styled from '@emotion/styled';
import { display, border, color, space, layout, compose, alignSelf, justifySelf, flex, flexGrow, flexShrink, flexBasis, order, gridColumn, gridRow, gridArea, position, system, textAlign, borderRadius, boxShadow, } from 'styled-system';
/**
 * Because Box is intended to be a child component, and not a flex, or grid, parent we only
 * support placing these properties on it.
 */
const flexboxParsers = [
    alignSelf,
    justifySelf,
    flex,
    flexGrow,
    flexShrink,
    flexBasis,
    order,
];
const gridParsers = [gridColumn, gridRow, gridArea];
/**
 * A generic layout/wrapper component that lets you apply a range
 * of common styles very quickly,like margins, paddings, colors and grid properties.
 */
export const Box = styled.div `
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'inherit')};
  ${compose(border, borderRadius, boxShadow, color, display, layout, position, space, textAlign, ...flexboxParsers, ...gridParsers)}
  ${system({
    cursor: true,
    transform: true,
    willChange: true,
})}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm94LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvYm94L0JveC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0saUJBQWlCLENBQUM7QUFDckMsT0FBTyxFQUNMLE9BQU8sRUFDUCxNQUFNLEVBQ04sS0FBSyxFQUNMLEtBQUssRUFDTCxNQUFNLEVBQ04sT0FBTyxFQUNQLFNBQVMsRUFDVCxXQUFXLEVBQ1gsSUFBSSxFQUNKLFFBQVEsRUFDUixVQUFVLEVBQ1YsU0FBUyxFQUNULEtBQUssRUFDTCxVQUFVLEVBQ1YsT0FBTyxFQUNQLFFBQVEsRUFDUixRQUFRLEVBQ1IsTUFBTSxFQUNOLFNBQVMsRUFDVCxZQUFZLEVBRVosU0FBUyxHQUVWLE1BQU0sZUFBZSxDQUFDO0FBc0N2Qjs7O0dBR0c7QUFDSCxNQUFNLGNBQWMsR0FBRztJQUNyQixTQUFTO0lBQ1QsV0FBVztJQUNYLElBQUk7SUFDSixRQUFRO0lBQ1IsVUFBVTtJQUNWLFNBQVM7SUFDVCxLQUFLO0NBQ04sQ0FBQztBQUVGLE1BQU0sV0FBVyxHQUFHLENBQUMsVUFBVSxFQUFFLE9BQU8sRUFBRSxRQUFRLENBQUMsQ0FBQztBQUVwRDs7O0dBR0c7QUFDSCxNQUFNLENBQUMsTUFBTSxHQUFHLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBVTtZQUMzQixDQUFDLEVBQUUsT0FBTyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQztJQUMxRCxPQUFPLENBQ1AsTUFBTSxFQUNOLFlBQVksRUFDWixTQUFTLEVBQ1QsS0FBSyxFQUNMLE9BQU8sRUFDUCxNQUFNLEVBQ04sUUFBUSxFQUNSLEtBQUssRUFDTCxTQUFTLEVBQ1QsR0FBRyxjQUFjLEVBQ2pCLEdBQUcsV0FBVyxDQUNmO0lBQ0MsTUFBTSxDQUFDO0lBQ1AsTUFBTSxFQUFFLElBQUk7SUFDWixTQUFTLEVBQUUsSUFBSTtJQUNmLFVBQVUsRUFBRSxJQUFJO0NBQzhCLENBQUM7Q0FDbEQsQ0FBQyJ9